import img from '@assets/Imgs/defaultTemplateImg.svg';

export const DEFAULT_TEMPLATE_IMG: string = img;
